import { Scenarios } from '@jfs/network'

const getAgentBankDetails = {
  default: [
    {
      url: /account\/getAccount/,
      method: 'POST',
      response: {
        status: 'SUCCESS',
        data: {},
      },
      delay: 500,
    },
  ],
  failed: [
    {
      url: /account\/getAccount/,
      method: 'POST',
      responseCode: 500,
      response: { status: 'FAILURE', error: { code: '33607', message: 'Agent does not exist.' } },
      delay: 1000,
    },
  ],
} as Scenarios

export { getAgentBankDetails }
